module.exports = __webpack_public_path__ + "static/media/mentor_mentoring_about1.55a55f95.webp";